import { targetingInterestsSagas } from './interest/sagas';

export const targetingSagas = [...targetingInterestsSagas];
